import { render, staticRenderFns } from "./welcomeGift.vue?vue&type=template&id=4be532c2&scoped=true"
import script from "./welcomeGift.vue?vue&type=script&lang=js"
export * from "./welcomeGift.vue?vue&type=script&lang=js"
import style0 from "./welcomeGift.vue?vue&type=style&index=0&id=4be532c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be532c2",
  null
  
)

export default component.exports